import { render, staticRenderFns } from "./AuthInitilizeForm.vue?vue&type=template&id=530169ca"
import script from "./AuthInitilizeForm.vue?vue&type=script&lang=js"
export * from "./AuthInitilizeForm.vue?vue&type=script&lang=js"
import style0 from "./AuthInitilizeForm.vue?vue&type=style&index=0&id=530169ca&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports